import { queryOptions } from '@tanstack/react-query';

import { SensorTypeCode } from '@/common/asset-sensor';
import { ROLE } from '@/common/role';
import type { TpsSectionChartRecord } from '@/common/sensors/tps/tps-section-chart';
import { usePermission } from '@/hooks/use-permission';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '@/queries/common';
import { API_URLS } from '@/queries/query.client';

export type TpsSectionChartResponse = {
	chartData: TpsSectionChartRecord[];
};

export type TpsSectionChartFilters = {
	points: string[];
};

export async function getTpsSectionChart(
	assetId: string,
	query: TpsSectionChartFilters,
): Promise<TpsSectionChartResponse | null> {
	const points = query.points.join(','); // Convert array to comma-separated string for API
	const response = await axios.get(`${API_URLS.ASSETS.SENSORS.TPS.SECTION_CHART(assetId)}`, {
		params: {
			...query,
			points: points ? points : undefined, // Only include points if it's not empty
		},
	});
	return getResponse<TpsSectionChartResponse>(response.data);
}

export const useQueryGetTpsSectionChart = (assetId: string, filters: TpsSectionChartFilters, enabled = true) => {
	const shouldRead = usePermission(ROLE.SENSORS_TPS_SECTION_READ);
	const isValidAssetId = !!assetId && assetId !== 'new';
	return queryOptions({
		queryKey: ['assets', assetId, 'sensors', SensorTypeCode.TPS, 'section-chart', filters],
		queryFn: () => getTpsSectionChart(assetId, filters),
		enabled: enabled && isValidAssetId && !!filters.points.length && shouldRead,
	});
};
